import { Component, OnInit, Sanitizer } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-multiple-video-call',
  templateUrl: './multiple-video-call.component.html',
  styleUrls: ['./multiple-video-call.component.scss']
})
export class MultipleVideoCallComponent {
  name;
  url;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(params);

      this.name = params.userid;

      console.log(this.name);

      this.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://realpulsewebdemo.onrender.com/chat.html?userid=' + this.name + '&nickname=' + this.name);
    });
  }

}
